import { connect } from "react-redux";
import SquareItem from "./SquareItem";
import { getDefaultStoreUrl } from "@template/state/modules/regionalStore";

function mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
}

export default connect(mapStateToProps)(SquareItem);
